// app/javascript/controllers/ui/rotating_text_controller.js

import { Controller } from "@hotwired/stimulus"

/**
 * Rotating Text Controller
 * 
 * Плавная анимация смены слов в тексте
 * 
 * @usedby app/views/welcome/_hero.html.erb
 * 
 * Usage:
 *   <span data-controller="ui--rotating-text" 
 *         data-ui--rotating-text-words-value='["Масштабируйте", "Запускайте", "Исследуйте", "Развивайте"]'
 *         data-ui--rotating-text-duration-value="3000">
 *     <span data-ui--rotating-text-target="text">Масштабируйте</span>
 *   </span>
 */
export default class extends Controller {
  static targets = ["text"]
  static values = {
    words: Array,
    duration: { type: Number, default: 3000 }, // время показа каждого слова (мс)
    fadeDuration: { type: Number, default: 500 }, // время fade анимации (мс)
    pauseOnHover: { type: Boolean, default: true }
  }

  connect() {
    if (!this.wordsValue || this.wordsValue.length === 0) {
      console.warn('[RotatingText] No words provided')
      return
    }

    this.currentIndex = 0
    this.isPaused = false
    this.animationId = null

    // Начинаем анимацию
    this.startRotation()

    // Пауза при hover если включено
    if (this.pauseOnHoverValue) {
      this.element.addEventListener('mouseenter', this.pause.bind(this))
      this.element.addEventListener('mouseleave', this.resume.bind(this))
    }
  }

  disconnect() {
    if (this.animationId) {
      clearTimeout(this.animationId)
    }
    if (this.pauseOnHoverValue) {
      this.element.removeEventListener('mouseenter', this.pause)
      this.element.removeEventListener('mouseleave', this.resume)
    }
  }

  startRotation() {
    if (this.isPaused) return

    // Показываем текущее слово
    this.showWord()

    // Планируем следующую смену
    this.animationId = setTimeout(() => {
      this.nextWord()
    }, this.durationValue)
  }

  nextWord() {
    if (this.isPaused) return

    // Fade out
    this.fadeOut(() => {
      // Меняем слово
      this.currentIndex = (this.currentIndex + 1) % this.wordsValue.length
      this.textTarget.textContent = this.wordsValue[this.currentIndex]

      // Fade in
      this.fadeIn(() => {
        // Продолжаем ротацию
        this.startRotation()
      })
    })
  }

  fadeOut(callback) {
    this.textTarget.style.transition = `opacity ${this.fadeDurationValue}ms ease-in-out`
    this.textTarget.style.opacity = '0'

    setTimeout(() => {
      if (callback) callback()
    }, this.fadeDurationValue)
  }

  fadeIn(callback) {
    // Небольшая задержка перед fade in для плавности
    setTimeout(() => {
      this.textTarget.style.transition = `opacity ${this.fadeDurationValue}ms ease-in-out`
      this.textTarget.style.opacity = '1'

      if (callback) {
        setTimeout(callback, this.fadeDurationValue)
      }
    }, 50)
  }

  showWord() {
    this.textTarget.textContent = this.wordsValue[this.currentIndex]
    this.textTarget.style.opacity = '1'
  }

  pause() {
    this.isPaused = true
    if (this.animationId) {
      clearTimeout(this.animationId)
    }
  }

  resume() {
    this.isPaused = false
    this.startRotation()
  }
}

